import React from 'react'
import { Checkbox, Popover, TextField, Tag } from '@runeffective/evo-design-system'
import { IAssetTag } from '@api'
import { useState } from 'react'

interface ItemProps {
  checked: boolean
  name: string
  onClick: any
  id: string
}

function AssetFilter({
  triggerElement,
  items,
  assetFilterSettings,
  updateAssetFilter,
}: {
  triggerElement: React.ReactNode
  items: IAssetTag[]
  assetFilterSettings: string[]
  updateAssetFilter: any
}) {
  const [searchQuery, setSearchQuery] = useState('')

  // Filter items based on the search query
  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(searchQuery.toLowerCase())
  )
  return (
    <Popover triggerElement={triggerElement}>
      <Popover.Content>
        {/* Search input field */}
        <TextField
          style={{
            margin: 10,
          }}
          placeholder="Search assets..."
          value={searchQuery}
          onChange={(value: string) => setSearchQuery(value)}
        />
        {filteredItems.map(({ id, name }: { id: string; name: string }) => {
          let checked = false
          if (assetFilterSettings?.length > 0) {
            checked = assetFilterSettings.includes(id)
          }
          return (
            <Item
              id={id}
              key={id}
              name={name}
              checked={checked}
              onClick={(event: any, id: string) => {
                updateAssetFilter(id, assetFilterSettings, event.target.checked)
              }}
            />
          )
        })}
      </Popover.Content>
    </Popover>
  )
}
function Item(props: ItemProps) {
  const { checked, name, onClick, id } = props

  return (
    <div style={{ margin: 10 }}>
      <Checkbox checked={checked} label={name} onChange={() => onClick(event, id)} />
    </div>
  )
}

export default AssetFilter
